import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'
  import useSegment from '@/composables/useSegment'
  import useCommonMixin from '@/composables/useCommonMixin'
  import Signup from '@/components/Signup.vue'
  import TextRenderer from '@/components/editor/TextRenderer.vue'
  import { UserModule } from '@/store/modules/user'
  import AcademyProfileUpdateForm from '@/components/signup/AcademyProfileUpdateForm.vue'
  import useI18n from '@/composables/useI18n'
  import CourseApi from '@/services/api/CourseApi'
  import CookieHelper from '@/helpers/CookieHelper'
  import OnboardingSurvey from '@/components/onboarding-survey/OnboardingSurvey.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AcademySignup',
  setup(__props) {

  const { trackPage, pageViewed } = useSegment()
  const {
    joinArrayOfStringsWithNewlineCharacter,
    setIsLoadingComponentViewData,
    academySignupBenefits,
    highlightedCourseBundlePrefix,
    fromEmbeddedQuiz,
    desktopLogo,
  } = useCommonMixin()
  const { translateString } = useI18n()

  const courseBundleSignupIntroText = ref('')
  const routingToNextOnboardingPage = ref(false)

  const stringifiedAcademyBenefits = computed(() => {
    if (!academySignupBenefits.value.length) return ''
    return joinArrayOfStringsWithNewlineCharacter(academySignupBenefits.value!)
  })

  const hasValidUser = computed(() => {
    return UserModule.hasValidUser
  })

  const userHasOnboarded = computed(() => {
    return UserModule.onboarded
  })

  const shouldShowProfileUpdate = computed(
    () =>
      (!userHasOnboarded.value &&
        hasValidUser &&
        (UserModule.currentCompany?.enableOnboardingSurvey
          ? !UserModule.currentCompany?.onboardingSurveyCompleted
          : true)) ||
      routingToNextOnboardingPage,
  )

  const showSetUserAccountView = computed(() => hasValidUser.value && !userHasOnboarded.value)

  const registerOrSetAccountText = computed(() =>
    showSetUserAccountView.value
      ? translateString('onboarding.profilePage.createUserAccount')
      : courseBundleSignupIntroText.value
        ? translateString('onboarding.customSignup.registerHereForFree')
        : translateString('onboarding.customSignup.register'),
  )

  const showOnboardingSurvey = computed(
    () => UserModule.currentCompany?.enableOnboardingSurvey && !UserModule.currentCompany?.onboardingSurveyCompleted,
  )

  const setIsAcademySignupCookie = () => {
    const isAcademySignup = CookieHelper.getCookieValue('is-academy-signup')

    if (!isAcademySignup) {
      CookieHelper.setCrossDomainCookie('is-academy-signup', 'true')
    }
  }

  const fetchCourseBundleSignupIntroText = () => {
    if (fromEmbeddedQuiz.value) {
      CookieHelper.setCrossDomainCookie('fromEmbeddedQuiz', fromEmbeddedQuiz.value)
      courseBundleSignupIntroText.value = translateString('onboarding.customSignup.freeExamQuestions')
    }

    if (highlightedCourseBundlePrefix.value) {
      CookieHelper.setCrossDomainCookie('bundlePrefix', highlightedCourseBundlePrefix.value)
      CourseApi.getCourseBundleSignupIntroText(highlightedCourseBundlePrefix.value).then(
        (resp) => (courseBundleSignupIntroText.value = resp.signupIntroText),
      )
    }
  }

  onMounted(() => {
    setIsAcademySignupCookie()

    if (userHasOnboarded.value) {
      CookieHelper.removeCrossDomainCookie('is-academy-signup')
      window.location.href = '/'
    } else if (!UserModule.hasValidUser) {
      trackPage('Academy Registration')
      pageViewed('Academy Registration')
    }

    fetchCourseBundleSignupIntroText()
    setIsLoadingComponentViewData(false)
  })

return { __sfc: true,trackPage, pageViewed, joinArrayOfStringsWithNewlineCharacter, setIsLoadingComponentViewData, academySignupBenefits, highlightedCourseBundlePrefix, fromEmbeddedQuiz, desktopLogo, translateString, courseBundleSignupIntroText, routingToNextOnboardingPage, stringifiedAcademyBenefits, hasValidUser, userHasOnboarded, shouldShowProfileUpdate, showSetUserAccountView, registerOrSetAccountText, showOnboardingSurvey, setIsAcademySignupCookie, fetchCourseBundleSignupIntroText, computed, onMounted, ref, useSegment, useCommonMixin, Signup, TextRenderer, UserModule, AcademyProfileUpdateForm, useI18n, CourseApi, CookieHelper, OnboardingSurvey }
}

})